import React from "react";
import Image from "next/image";
import { AuthLogout } from "../../api";
import { useTranslation } from "../../../context/TranslationContext";
import BackButton from "../../BackButton";

const TopBar = ({ checkLogin, setLoading, isAppWebView, customerName }) => {
  const { reservations, welcome, logout, accountDelete } = useTranslation();
  const handleClick = () => {
    setLoading(true);
    AuthLogout()
      .then((data) => {
        if (data.data.success) {
          checkLogin();
        }
      })
      .catch((e) => {});
  };

  return (
    <div className="flex justify-between items-start mb-8 gap-4">
      <div className="flex flex-col">
        <BackButton isAppWebView={isAppWebView} top="top-0" />
        <span className="font-bold text-[14px] leading-[19px] text-[#0176AB] mt-4">
          {reservations.title}
        </span>
        <span className="font-bold text-[#333738] text-[30px] leading-10">
          {welcome} {customerName}
        </span>
        <a
          href="https://members.villavillam.com.tr/"
          target="_blank"
          rel="noreferrer"
          className="text-xs font-semibold text-red-500 hover:underline mt-1 sm:hidden"
        >
          {accountDelete}
        </a>
      </div>
      <div className="flex items-center gap-4 shrink-0">
        <a
          href="https://members.villavillam.com.tr/"
          target="_blank"
          rel="noreferrer"
          className="hidden sm:block text-xs font-semibold text-red-500 hover:underline"
        >
          {accountDelete}
        </a>
        {!isAppWebView && (
          <button
            type="button"
            onClick={handleClick}
            className="btn flex items-center"
          >
            <div className="relative w-9 h-9">
              <Image
                src={"/images/shutdown.png"}
                layout="fill"
                alt=""
                objectFit="contain"
              />
            </div>
            <span className="ml-3 text-13 font-semibold">{logout}</span>
          </button>
        )}
      </div>
    </div>
  );
};

export default TopBar;
